/** @format */

import React, { useRef, useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import Card from "./Card";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    tooltip: {
      callbacks: {
        // TUZATILDI: Tooltip tepasida qaysi soat ekanligini aniq ko'rsatadi
        title: (context) => `Soat: ${context[0].label}:00`,
        label: (context) => `${context.parsed.y} m³/s`,
      },
      backgroundColor: "#6C2BD9",
      bodyFont: { size: 13 },
      cornerRadius: 8,
      padding: 10,
    },
    datalabels: {
      display: false,
    },
  },
  scales: {
    y: {
      grid: {
        color: "#B5B5C3",
      },
      border: {
        dash: [2, 2],
      },
      stacked: true,
      beginAtZero: true,
    },
    x: {
      grid: {
        drawOnChartArea: false,
        color: "#B5B5C3",
      },
      ticks: {
        maxRotation: 0,
        minRotation: 0,
        color: "#6B7280",
      },
    },
  },
  elements: {
    point: {
      radius: 3,
      hoverRadius: 4,
      backgroundColor: "#4ADE80",
      borderWidth: 1,
      borderColor: "#fff",
    },
    line: {
      tension: 0.4,
    },
  },
};

const labels = [
  "1",
  "3",
  "5",
  "7",
  "9",
  "11",
  "13",
  "15",
  "17",
  "19",
  "21",
  "23",
];

const Chart5 = ({ data }) => {
  const chartRef = useRef(null);
  const [gradient, setGradient] = useState(null);

  useEffect(() => {
    if (chartRef.current) {
      const ctx = chartRef.current.ctx;
      const grad = ctx.createLinearGradient(0, 0, 0, 200);
      grad.addColorStop(0, "rgba(151,71,255, 0.35)");
      grad.addColorStop(1, "rgba(151,71,255, 0)");
      setGradient(grad);
    }
  }, []);

  const datas = {
    labels,
    datasets: [
      {
        label: "m3/s",
        data: data,
        borderColor: "rgb(151,71,255)",
        backgroundColor: gradient,
        fill: true,
      },
    ],
  };

  return (
      <Card>
        <div className='chart-box-all'>
          <div>
            {/* TUZATILDI: "soatlik" rejimi xira va mos tushadigan dizaynda yozildi */}
            <h4 className='chart-title'>
              Ziyaiddin G/P{" "}
              <span className='lower' style={{ opacity: 0.75, marginLeft: '4px' }}>
              soatlik (m<sup>3</sup>/s)
            </span>
            </h4>

            <Line ref={chartRef} options={options} data={datas} height={80} />
          </div>
        </div>
      </Card>
  );
};

export default Chart5;